export default __webpack_public_path__ + "72f3912ab3faca8b2ecce205a1c9893e.svg";